export default {
  active: 'purple',
  purple: {
    base: '#3F3175',
  },
  green: { base: '#066F26' },
  grey: { base: '#4F4F4F' },
  white: { base: '#FFFFFF' },
  pink: {
    base: '#87085B',
  },
  navyBlue: { base: '#251679' },
  neon: { base: '#055D56' },
  paleBlue: { base: '#0FCBEE' },
  red: {
    base: '#670008',
  },
  darkOrange: { base: '#974608' },
  brightOrange: { base: '#D44208' },
  orange: { base: '#FFA43B' },
};
